import React, { useState } from "react";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import classNames from "classnames";
import * as Yup from "yup";
import { InputText } from "primereact/inputtext";
import { handlePostRequest } from "../../services/PostTemplate";

const VerifyAtmCardStatus = ({ handleReturnData, title, api }) => {
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("");

    const validationSchema = Yup.object().shape({
        cardNumber: Yup.string().required("This field is required.").min(16, "Card Number must be 16 digits").max(16, "Card Number must be 16 digits"),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            cardNumber: "",
        },
        onSubmit: async (data) => {
            try {
                setloading(true);
                setloadingIcon("pi pi-spin pi-spinner");
                const res = await handlePostRequest(data, api);
                handleReturnData(res?.data, data.cardNumber);
            } catch (error) {
                console.log('error', error)
                if (error.response.data.messages === "User not found")
                    handleReturnData(undefined);
            }
            finally {
                setloading(false);
                setloadingIcon("pi pi-save");
            }
        },
    });
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };
    return (
        <div className="card Card__Round">
            <div className="Form__Header">
                <h1> {title} </h1>
            </div>
            <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                <div className="p-fluid p-formgrid p-grid">
                    <div className="p-field p-col-12 p-md-6">
                        <div className="p-field">
                            <label htmlFor="cardNumber" className={classNames({ "p-error": isFormFieldValid("cardNumber") }, "Label__Text")}>
                                Atm Card Number<span className="Label__Required">*</span>
                            </label>
                            <InputText id="cardNumber" placeholder="" name="cardNumber" value={formik?.values?.cardNumber} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("cardNumber") }, "Input__Round")} keyfilter={/^[0-9]+$/} />
                            {getFormErrorMessage("cardNumber")}
                        </div>
                    </div>
                </div>

                <div className="Down__Btn">
                    <Button disabled={loading} icon={loadingIcon || ""} iconPos="right" label={"Search"} className="Btn__Dark" />
                </div>
            </form>
        </div>
    );
};

export default VerifyAtmCardStatus;
